import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../i18n/language.service';

@Component({
  selector: 'app-who-do-we-work-for-day',
  standalone: false,
  templateUrl: './who-do-we-work-for-day.component.html',
  styleUrls: ['./who-do-we-work-for-day.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhoDoWeWorkForDayComponent {
  constructor(public language: LanguageService) {}
}
